const UserConverter = ({ emailId, phoneNumber, ...rest }): any => {
	if (phoneNumber) {
		return {
			emailId,
			phoneNumber,
			data: {
				...rest,
			},
		};
	} else {
		return {
			emailId,
			data: {
				...rest,
			},
		};
	}
};

export default UserConverter;
